import { getSpaceIdFromPath } from "./utils";
import { isNotNil } from "gather-common/dist/src/public/fpHelpers";
function isStorageAvailable() {
    try {
        const storage = window.localStorage;
        const x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch (e) {
        return false;
    }
}
const mockMemory = {};
const mockedLocalStorage = {
    memory: mockMemory,
    getItem: function (key) {
        return this.memory[key] ?? null;
    },
    setItem: function (key, value) {
        return (this.memory[key] = value);
    },
    clear: function () {
        this.memory = {};
    },
    removeItem: function (key) {
        delete this.memory[key];
    },
    key: function (idx) {
        return Object.keys(this.memory)[idx] || null;
    },
    length: function () {
        return Object.keys(this.memory).length;
    },
};
const localStorage = isStorageAvailable() ? window.localStorage : mockedLocalStorage;
class LocalPreferences {
    set(key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        }
        catch (e) {
            return;
        }
    }
    delete(key) {
        localStorage.removeItem(key);
    }
    get(key) {
        const value = localStorage.getItem(key);
        if (value === null)
            return undefined;
        try {
            return JSON.parse(value);
        }
        catch (err) {
            return undefined;
        }
    }
    getKey(key) {
        return this.get(key);
    }
    setForRoom(key, value, roomId) {
        const room = roomId || getSpaceIdFromPath();
        if (room !== null) {
            this.set(getRoomKey(room, key), value);
        }
    }
    getForRoom(key, roomId) {
        const room = roomId || getSpaceIdFromPath();
        if (room !== null)
            return this.get(getRoomKey(room, key));
    }
    deleteForRoom(key, roomId) {
        const room = roomId || getSpaceIdFromPath();
        if (room !== null) {
            this.delete(getRoomKey(room, key));
        }
    }
    setForUser(key, value, userId) {
        if (isNotNil(userId)) {
            this.set(getUserKey(userId, key), value);
        }
    }
    getForUser(key, userId) {
        if (isNotNil(userId))
            return this.get(getUserKey(userId, key));
    }
    deleteForUser(key, userId) {
        if (isNotNil(userId)) {
            this.delete(getUserKey(userId, key));
        }
    }
}
function getRoomKey(roomId, key) {
    return `${roomId}/${key}`;
}
function getUserKey(userId, key) {
    return `${userId}/${key}`;
}
export var LocalPreferenceKeys;
(function (LocalPreferenceKeys) {
    LocalPreferenceKeys["ExpSoundsVolumeSettings"] = "expSoundsVolumeSettings";
    LocalPreferenceKeys["PreferHDVideos"] = "preferHDVideos";
    LocalPreferenceKeys["MirrorSelfVideo"] = "mirrorSelfVideo";
    LocalPreferenceKeys["HideSelfVideo"] = "hideSelfVideo";
    LocalPreferenceKeys["AutoLowerHand"] = "autoLowerHand";
    LocalPreferenceKeys["AudioDeviceId"] = "audioDeviceId";
    LocalPreferenceKeys["VideoDeviceId"] = "videoDeviceId";
    LocalPreferenceKeys["AudioOutputDeviceId"] = "audioOutputDeviceId";
    LocalPreferenceKeys["AudioMuteClicked"] = "audioMuteClicked";
    LocalPreferenceKeys["VideoMuteClicked"] = "videoMuteClicked";
    LocalPreferenceKeys["LastConversation"] = "lastConversation";
    LocalPreferenceKeys["SentFirstChat"] = "sentFirstChat";
    LocalPreferenceKeys["MapCategoriesEntered"] = "mapCategoriesEntered";
    LocalPreferenceKeys["OAuthReturnTo"] = "oauthReturnTo";
    LocalPreferenceKeys["EnteredSpace"] = "EnteredSpace";
    LocalPreferenceKeys["UseSmartZoom"] = "useSmartZoom";
    LocalPreferenceKeys["ManualCanvasZoom"] = "manualCanvasZoom";
    LocalPreferenceKeys["ManualCanvasZoomEvent"] = "manualCanvasZoomEvent";
    LocalPreferenceKeys["MobileMovementOverlayDismissed"] = "mobileMovementOverlayDismissed";
    LocalPreferenceKeys["SeenAudioBubbles"] = "SeenAudioBubbles";
    LocalPreferenceKeys["FreeformTutorialDismissed"] = "freeformTutorialDismissed";
    LocalPreferenceKeys["MobileJoystickOverlayDismissed"] = "mobileJoystickOverlayDismissed";
    LocalPreferenceKeys["UserHomeTab"] = "userHomeTab";
    LocalPreferenceKeys["CustomEmotes"] = "customEmotes";
    LocalPreferenceKeys["MobileAudioOnlyModeToastSeen"] = "mobileAudioOnlyModeToastSeen";
    LocalPreferenceKeys["MobileAudioOnlyModeUsed"] = "mobileAudioOnlyModeUsed";
    LocalPreferenceKeys["FeatureGateOverrides"] = "featureGateOverrides";
    LocalPreferenceKeys["VariantGateOverrides"] = "VariantGateOverrides";
    LocalPreferenceKeys["FeatureGateDisableOverrides"] = "featureGateDisableOverrides";
    LocalPreferenceKeys["LockDeskMessageDismissed"] = "lockDeskMessageDismissed";
    LocalPreferenceKeys["DeskVolume"] = "deskVolume";
    LocalPreferenceKeys["PrivateSpaceTutorialSeen"] = "privateSpaceTutorialSeen";
    LocalPreferenceKeys["StatusHistory"] = "statusHistory";
    LocalPreferenceKeys["HasSeenNotificationModal"] = "hasSeenNotificationModal";
    LocalPreferenceKeys["MobileObjectInteractionFullscreenUIToastSeen"] = "mobileObjectInteractionFullscreenUIToastSeen";
    LocalPreferenceKeys["UserHWAcceleration"] = "userHWAcceleration";
    LocalPreferenceKeys["UserPrefersReducedMotion"] = "userPrefersReducedMotion";
    LocalPreferenceKeys["HasSeenHelpModalPopup"] = "hasSeenHelpModalPopup";
    LocalPreferenceKeys["UserHasCappedFPS"] = "userHasCappedFPS";
    LocalPreferenceKeys["PowerSaverMode"] = "reducePerfWhenWindowBlurred";
    LocalPreferenceKeys["PortalPlayerInfo"] = "portalPlayerInfo";
    LocalPreferenceKeys["GridViewTipSeen"] = "gridViewTipSeen";
    LocalPreferenceKeys["MapViewTipSeen"] = "mapViewTipSeen";
    LocalPreferenceKeys["VideoLargeGrid"] = "videoLargeGrid";
    LocalPreferenceKeys["RORIntroShowed"] = "RORIntroShowed";
    LocalPreferenceKeys["JukeboxVolume"] = "jukeboxVolume";
    LocalPreferenceKeys["EnableCalendarSound"] = "enableCalendarSound";
    LocalPreferenceKeys["EnableRequestNotificationSound"] = "enableRequestToLeadOrJoinSound";
    LocalPreferenceKeys["MapSoundsSlider"] = "userSettings/localMapSoundsSlider";
    LocalPreferenceKeys["OfficeConfigurationWarning"] = "configureOfficeWarning";
    LocalPreferenceKeys["HasSeenOfficeConfigurationNew"] = "hasSeenOfficeConfigurationNew";
    LocalPreferenceKeys["HasSeenUserEducationPrivateAreasInSpace"] = "hasSeenUserEducationPrivateAreasInSpace";
    LocalPreferenceKeys["HasSeenUserEducationPrivateAreasInMapmaker"] = "hasSeenUserEducationPrivateAreasInMapmaker";
    LocalPreferenceKeys["HasSeenUserEducationCalendarIntegration"] = "hasSeenUserEducationCalendarIntegration";
    LocalPreferenceKeys["HasSeenUserEducationCurrentAreaSettings"] = "hasSeenUserEducationCurrentAreaSettings";
    LocalPreferenceKeys["HasSeenUserEducationDeskWidget"] = "hasSeenUserEducationDeskWidget";
    LocalPreferenceKeys["HasSeenUserEducationNewProfile"] = "hasSeenUserEducationNewProfile";
    LocalPreferenceKeys["HasSeenUserEducationNewBuild"] = "hasSeenUserEducationNewBuild";
    LocalPreferenceKeys["HasSeenUserEducationManageGuestPass"] = "HasSeenUserEducationManageGuestPass";
    LocalPreferenceKeys["HasSeenUserEducationRecentGuests"] = "HasSeenUserEducationRecentGuests";
    LocalPreferenceKeys["HasSeenUserEducationGuestCheckInModal"] = "hasSeenUserEducationGuestCheckInModal";
    LocalPreferenceKeys["HasSeenUserEducationSpaceCreatorOnboarding"] = "hasSeenUserEducationSpaceCreatorOnboarding";
    LocalPreferenceKeys["RwOnboardingV3EndComplete"] = "rwOnboardingV3EndComplete";
    LocalPreferenceKeys["LastSawSpaceAtCapacityNotification"] = "lastSawSpaceAtCapacityNotification";
    LocalPreferenceKeys["LastSawSpaceExceededCapacityNotification"] = "lastSawSpaceExceededCapacityNotification";
    LocalPreferenceKeys["LastSawUserDeniedEntryNotification"] = "lastSawUserDeniedEntryNotification";
    LocalPreferenceKeys["RecentUploadedObjects"] = "recentUploadedObjects";
    LocalPreferenceKeys["RecentText"] = "recentText";
    LocalPreferenceKeys["LastSelectedReservationPlan"] = "lastSelectedReservationPlan";
    LocalPreferenceKeys["HasSeenSkipCyhScreenModal"] = "hasSeenSkipCyhScreenModal";
    LocalPreferenceKeys["VideoEffect"] = "videoEffect";
    LocalPreferenceKeys["MiniModeLastDeskModePosition"] = "MiniModeLastDeskModePosition";
    LocalPreferenceKeys["MiniModeLastVideoModePosition"] = "MiniModeLastVideoModePosition";
    LocalPreferenceKeys["MiniModeLastNavModePosition"] = "MiniModeLastNavModePosition";
    LocalPreferenceKeys["MiniModeLastVideoPopOutPosition"] = "MiniModeLastVideoPopOutPosition";
    LocalPreferenceKeys["MiniModeAutoCollapse"] = "MiniModeAutoCollapse";
    LocalPreferenceKeys["HasSeenMiniModeOnboarding"] = "hasSeenMiniModeOnboarding";
    LocalPreferenceKeys["LastSentChatTime"] = "lastSentChatTime";
    LocalPreferenceKeys["RecordingWarningDontShowAgain"] = "RecordingWarningDontShowAgain";
    LocalPreferenceKeys["HasSeenTabDiscardWarning"] = "hasSeenTabDiscardWarning";
    LocalPreferenceKeys["NoiseReduction"] = "noiseReduction-X";
    LocalPreferenceKeys["KrispNoiseReduction"] = "krispNoiseReduction-X";
    LocalPreferenceKeys["EchoCancellation"] = "echoCancellation";
    LocalPreferenceKeys["GainControl"] = "gainControl";
    LocalPreferenceKeys["SelectedLanguage"] = "selectedLanguage";
    LocalPreferenceKeys["HasSeenMobileAppAnnouncement"] = "hasSeenMobileAppAnnouncement";
    LocalPreferenceKeys["HasSeenLocalizationAnnouncement"] = "hasSeenLocalizationAnnouncement";
    LocalPreferenceKeys["SeenDesktopCalendarNudge"] = "seenDesktopCalendarNudge";
    LocalPreferenceKeys["DoNotShowDesktopOsWarning"] = "DoNotShowDesktopOsWarning";
    LocalPreferenceKeys["DesktopOsWarningLastDismissed"] = "DesktopOsWarningLastDismissed";
    LocalPreferenceKeys["DesktopDontShowQuitModal"] = "DesktopDontShowQuitModal";
    LocalPreferenceKeys["NumTimesSeenDesktopRedirect"] = "numTimesSeenDesktopRedirect";
    LocalPreferenceKeys["DoNotShowDesktopRedirect"] = "doNotShowDesktopRedirect";
    LocalPreferenceKeys["HasSeenAmbientDeskEducation"] = "hasSeenAmbientDeskEducation";
    LocalPreferenceKeys["HasSeenEditPodLabelEducation"] = "hasSeenEditPodLabelEducation";
    LocalPreferenceKeys["HasSeenCoworkingEducation"] = "hasSeenCoworkingEducation";
    LocalPreferenceKeys["PerformanceSurveyIncompleteResponses"] = "performanceSurveyResponses";
    LocalPreferenceKeys["RatingModalClosedLastTime"] = "ratingModalLastClosed";
    LocalPreferenceKeys["GatherLiteSwitchToMapTipSeen"] = "gatherLiteSwitchToMapTipSeen";
    LocalPreferenceKeys["GatherLiteSwitchToGridTipSeen"] = "gatherLiteSwitchToGridTipSeen";
    LocalPreferenceKeys["NewMeetingUxViewToggleEducationTipSeen"] = "NewMeetingUxViewToggleEducationTipSeen";
    LocalPreferenceKeys["AudioRaw"] = "audioRaw";
    LocalPreferenceKeys["RefreshTrackingData"] = "refreshTrackingData";
    LocalPreferenceKeys["PhysicsParams"] = "PhysicsParams";
    LocalPreferenceKeys["DontResetPhysics"] = "DontResetPhysics";
    LocalPreferenceKeys["ShouldLogGatherLabsEvent"] = "ShouldLogGatherLabsEvent";
    LocalPreferenceKeys["KrispNewBadge"] = "KrispNewBadge";
    LocalPreferenceKeys["SeenWhatsNewSlides"] = "SeenWhatsNewSlides";
    LocalPreferenceKeys["SeenInsightsWelcome"] = "SeenInsightsWelcome";
    LocalPreferenceKeys["SeenInsightsLowData"] = "SeenInsightsLowData";
    LocalPreferenceKeys["PhaserContextLostState"] = "PhaserContextLostState";
    LocalPreferenceKeys["HasSeenOfficeAddinValuePage"] = "hasSeenOfficeAddinValuePage";
    LocalPreferenceKeys["SeenChatV2EduOverlay"] = "SeenChatV2EduOverlay";
    LocalPreferenceKeys["PhaserFallbackToCanvasLastStartup"] = "PhaserFallbackToCanvasLastStartup";
    LocalPreferenceKeys["ChatDraftMessages"] = "chatDraftMessages";
    LocalPreferenceKeys["FailedSubscriptionNotifications"] = "failedSubscriptionNotifications";
    LocalPreferenceKeys["DefaultPinSide"] = "defaultPinSide";
    LocalPreferenceKeys["FinishedSurveys"] = "FinishedSurveys";
    LocalPreferenceKeys["SurveyResponses"] = "SurveyResponses";
    LocalPreferenceKeys["KrispForceReenableDone"] = "KrispForceReenableDone";
    LocalPreferenceKeys["FirstSpaceCreationDateMetric"] = "FirstSpaceCreationDateMetric";
    LocalPreferenceKeys["SummarizeMeetingRecordingsWithAi"] = "SummarizeMeetingRecordingsWithAi";
    LocalPreferenceKeys["AutoBusy"] = "autoBusy";
    LocalPreferenceKeys["AmbientVideoModelType"] = "ambientVideoModelType";
    LocalPreferenceKeys["AmbientAudioDecayEnabled"] = "ambientAudioDecayEnabled";
    LocalPreferenceKeys["UnfocusedVolume"] = "unfocusedVolume";
    LocalPreferenceKeys["BackgroundConversationFade"] = "backgroundConversationFade";
    LocalPreferenceKeys["PMMDistThreshold"] = "PMMDistThreshold";
})(LocalPreferenceKeys || (LocalPreferenceKeys = {}));
export var LocalPreferenceRoomKeys;
(function (LocalPreferenceRoomKeys) {
    LocalPreferenceRoomKeys["PredeterminedGateValues"] = "predeterminedGateValues";
    LocalPreferenceRoomKeys["Sprite"] = "sprite";
    LocalPreferenceRoomKeys["Blocked"] = "blocked";
    LocalPreferenceRoomKeys["BlockedBy"] = "blockedBy";
    LocalPreferenceRoomKeys["IsChatMuted"] = "isChatMuted";
    LocalPreferenceRoomKeys["ChatSoundsSetting"] = "ChatSoundsSetting";
    LocalPreferenceRoomKeys["OnboardingInviteShown"] = "onboardingInviteShown";
    LocalPreferenceRoomKeys["PersistedChatMessages"] = "persistedChatMessages";
    LocalPreferenceRoomKeys["RWGuideKioskPlaced"] = "RWGuideKioskPlaced";
    LocalPreferenceRoomKeys["GatherEventACLShown"] = "GatherEventACLShown";
    LocalPreferenceRoomKeys["LastSpawnedTime"] = "lastSpawnedTime";
    LocalPreferenceRoomKeys["RORRemoved"] = "RORRemoved";
    LocalPreferenceRoomKeys["SpawnLinks"] = "spawnLinks";
    LocalPreferenceRoomKeys["RoomOfRequirementsInfoSeen"] = "roomOfRequirementsInfoSeen";
    LocalPreferenceRoomKeys["SocialInviteLink"] = "SocialInviteLink";
    LocalPreferenceRoomKeys["MovedFirstTime"] = "movedFirstTime";
    LocalPreferenceRoomKeys["BoardGameOnboardingSeen"] = "boardGameOnboardingSeen";
    LocalPreferenceRoomKeys["BoardGameChatOnboardingSeen"] = "boardGameChatOnboardingSeen";
    LocalPreferenceRoomKeys["BrowserExtensionMessageDismissed"] = "browserExtensionMessageDismissed";
    LocalPreferenceRoomKeys["MsOfficeAddinMessageDismissed"] = "msOfficeAddinMessageDismissed";
    LocalPreferenceRoomKeys["DisableAutoMute"] = "userSettings/disableAutoMute";
    LocalPreferenceRoomKeys["SpawnPoints"] = "spawnPoints";
    LocalPreferenceRoomKeys["HasMigratedRecurringMeetings"] = "hasMigratedRecurringMeetings";
    LocalPreferenceRoomKeys["LastSessionUpdate"] = "lastSessionUpdate";
    LocalPreferenceRoomKeys["SessionCount"] = "sessionCount";
    LocalPreferenceRoomKeys["BookableAreas"] = "bookableAreas";
    LocalPreferenceRoomKeys["DisableCreateEventReminder"] = "disableCreateEventReminder";
    LocalPreferenceRoomKeys["LastShownCreateEventReminder"] = "lastShownCreateEventReminder";
    LocalPreferenceRoomKeys["SkipCyhScreen"] = "skipCyhScreen";
    LocalPreferenceRoomKeys["RecentObjects"] = "recentObjects";
    LocalPreferenceRoomKeys["GiftAutoCleanUp"] = "giftAutoCleanUp";
    LocalPreferenceRoomKeys["CreatorOnboardingShowDeskOnboarding"] = "creatorOnboardingShowDeskOnboarding";
    LocalPreferenceRoomKeys["HasSeenFreeTrialNotice"] = "hasSeenFreeTrialNotice";
    LocalPreferenceRoomKeys["HasSeenFreeTrialExpiringNotice"] = "hasSeenFreeTrialExpiringNotice";
    LocalPreferenceRoomKeys["HasSeenFreeTrialExpiredNotice"] = "hasSeenFreeTrialExpiredNotice";
    LocalPreferenceRoomKeys["GuestCheckInLastSelectedOption"] = "guestCheckInLastSelectedOption";
    LocalPreferenceRoomKeys["OnboardingSurveyResponses"] = "onboardingSurveyResponses";
    LocalPreferenceRoomKeys["SpaceOnboardingStep"] = "spaceOnboardingStep";
    LocalPreferenceRoomKeys["HasSeenSubscriptionCanceledBanner"] = "hasSeenSubscriptionCanceledBanner";
    LocalPreferenceRoomKeys["HasAcknowledgedGatherLabsMapmakerDisclaimer"] = "hasAcknowledgedGatherLabsMapmakerDisclaimer";
    LocalPreferenceRoomKeys["OnboardingChecklistFirstDayTimeStamp"] = "onboardingChecklistFirstDayTimeStamp";
})(LocalPreferenceRoomKeys || (LocalPreferenceRoomKeys = {}));
export var LocalPreferenceUserKeys;
(function (LocalPreferenceUserKeys) {
    LocalPreferenceUserKeys["SelectedMeetingSpace"] = "selectedMeetingSpace";
})(LocalPreferenceUserKeys || (LocalPreferenceUserKeys = {}));
const localPreferences = new LocalPreferences();
export { localPreferences };
//# sourceMappingURL=LocalPreferences.js.map